import React from 'react';
import '../assets/styles.css';
import stockFootage from '../assets/stock-video.mp4';
import { FaVideo, FaPhone } from 'react-icons/fa';

export default function HomeSectionA() {
  return (
    <div>
      {/* Hero Section with Video Background */}
      <div className="relative overflow-hidden bg-gray-900">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover filter brightness-50"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <source src={stockFootage} type="video/mp4" />
        </video>
        
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/50 sm:bg-black/40"></div>
        
        <div
          className="relative z-10 min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <div className="max-w-6xl mx-auto text-center">
            {/* PADPRO text in green - Enhanced responsive sizing */}
            <h2 className="text-[#6BAF43] font-serif text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl mb-4 sm:mb-6 lg:mb-8">
              PADPRO
            </h2>
            
            {/* Main heading with mixed styling - Enhanced responsive design */}
            <div className="text-white leading-relaxed space-y-2 sm:space-y-1">
              <div className="font-serif text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
                <span>philosophy hinges on{' '}</span>
                <span className="italic text-[#6BAF43]">Self-Help</span>
              </div>
              
              <div className="font-serif text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
                <span className="italic text-[#6BAF43]">Advocacy</span>
                <span>{' '}through{' '}</span>
                <span className="italic text-[#6BAF43]">Responsive</span>
              </div>
              
              <div className="font-serif text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
                <span className="italic text-[#6BAF43]">Programming</span>
                <span>{' '}</span>
                <span className="italic text-[#6BAF43]">S.H.A.R.P</span>
                <span>{')'}</span>
              </div>
              
              <div className="font-serif text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
                <span>using a{' '}</span>
                <span className="italic text-[#6BAF43]">Person-Centered</span>
                <span>{' '}Approach.</span>
              </div>
            </div>
            
            {/* Call to Action Buttons - Enhanced responsive design */}
            <div className="mt-8 sm:mt-10 lg:mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4 sm:px-0">
              <button className="w-full sm:w-auto bg-white text-black px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-medium flex items-center justify-center gap-2 hover:bg-gray-100 transition-all duration-200 hover:scale-105 text-sm sm:text-base">
                <FaVideo className="text-gray-700 text-sm sm:text-base" />
                <span>WATCH OUR PROGRAM</span>
              </button>
              <button className="w-full sm:w-auto bg-[#FF4444] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-medium flex items-center justify-center gap-2 hover:bg-red-600 transition-all duration-200 hover:scale-105 text-sm sm:text-base">
                <FaPhone className="text-sm sm:text-base" />
                <span>(408) 347 - 0402</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Text Section Below - Enhanced responsive design */}
      <div className="bg-white py-12 sm:py-16 lg:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
          <div className="text-center" data-aos="fade-up" data-aos-duration="2000">
            <h2 className="newsreader text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-6 sm:mb-8 lg:mb-12 leading-tight">
              Empowering Independence Through Person-Centered Programming
            </h2>
            
            <div className="space-y-6 sm:space-y-8 text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed max-w-5xl mx-auto">
              <p className="text-left sm:text-justify">
                <strong className="text-gray-900">Piedmont Adult Day Program (PADPRO)</strong> is a behavior management adult program that{' '}
                <span className="text-green-700 font-semibold">
                  provides quality services to address severe behavior issues and skill acquisition needs of adults with intellectual disabilities
                </span>{' '}
                in the least restrictive environment possible. It is both a community and site-based program, with facilities designed to work toward the elimination of behaviors that prevent the individual from progressing while encouraging choices and options for adaptive, age-appropriate skills during community integration.
              </p>
              
              <p className="text-left sm:text-justify">
                <span className="text-green-700 font-semibold">
                  The PADPro philosophy hinges on Self-help Advocacy through Responsive Programming (S.H.A.R.P.).
                </span>{' '}
                This approach empowers individuals through the principles of normalization and community integration. PADPro adheres to the{' '}
                <span className="text-green-700 font-semibold">
                  Final Rule of Home and Community-Based Services (HCBS), using a person-centered approach
                </span>{' '}
                that places the individual at the center, focusing on what is important to and for the individual.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}